import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLock"><Path d="M4.5 9.5H19.5V21.5H4.5V9.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 9.25V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V9.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><Path d="M12 14V17" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLock;
